import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { DatePickerModal } from 'ziphy-web-shared/basic/lib/functional';
import { BadgeNew } from 'ziphy-web-shared/basic/lib/simple';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import PlaceholderHelpers from '@nedoShared/modules/notes/placeholder/Placeholder.helpers';
import styles from './PlaceholderDate.module.scss';
const { getBadgeColor } = PlaceholderHelpers;
const PlaceholderDate = ({ elementId, data, isBlocked, isLoading, onChange, isPlain, isInvalid, }) => {
    const handleClick = () => {
        $modal.add(DatePickerModal, {
            type: 'selectDay',
            selectedDate: typeof data.value === 'string' ? data.value : new Date().toString(),
            onChange: (date) => onChange(data.id, { value: date }),
            scrollTo: 'start',
        });
    };
    return (_jsx(BadgeNew, { id: elementId, valueId: `ref_${data.id}`, value: data.value ? formatDate(data.value, data.format) : undefined, placeholder: data.title, editable: !isBlocked && !data.blocked && !isPlain, color: getBadgeColor(data), className: classNames(styles.badge, {
            [styles.badgeGray]: isBlocked,
            [styles.badgePurple]: data.blocked && data.source === 'system',
        }), "data-placeholder": true, showTextSelection: false, onClick: handleClick, isLoading: isLoading, isPlain: isPlain, isInvalid: isInvalid }));
};
export default PlaceholderDate;
